import * as React from 'react';
import { Layout } from '../Layout';
import * as styles from './SpecialPromos.css';

interface ISpecialPromosProps {
  title: React.ReactNode;
  slider: React.ReactNode;
  discounts: React.ReactNode;
}

export function SpecialPromos({ title, slider, discounts }: ISpecialPromosProps) {
  return (
    <section id="promos" className={styles['container']}>
      <Layout>
        <div className={styles['title']}>{title}</div>
        <div className={styles['slider']}>{slider}</div>

        <div className={styles['discounts']}>{discounts}</div>
      </Layout>
    </section>
  );
}
